module.exports = __webpack_public_path__ + "static/media/score.7651cb52.png";